export const filterByCity = (matches, cities) =>
    matches.filter((item) => cities.includes(item.venue?.location));
